import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import SectionEyebrow from "@/components/common/SectionEyebrow";
import { publicApi } from "@/lib/api";
import { ArrowRight, Check } from "lucide-react";

export default function Alliance() {
  const [page, setPage] = useState(null);
  useEffect(() => {
    publicApi.page("alliance").then(setPage).catch(() => {});
  }, []);
  const p = page || {};
  return (
    <PublicLayout title="The Alliance">
      <section className="relative bsca-dark bsca-cosmic bsca-grain -mt-16 md:-mt-20 lg:-mt-[88px] pt-36 md:pt-44 pb-24 overflow-hidden">
        <div className="bsca-field-lines" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
          <div className="max-w-3xl bsca-fade-up">
            <SectionEyebrow dark>{p.hero?.eyebrow || "About BSCA"}</SectionEyebrow>
            <h1 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              {p.hero?.headline}
            </h1>
            <p className="mt-6 text-white/75 text-lg leading-relaxed">{p.hero?.subheadline}</p>
          </div>
        </div>
      </section>

      <section className="bg-[#F8F6F1] py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <SectionEyebrow>{p.what_is?.title || "What is BSCA?"}</SectionEyebrow>
            <h2 className="font-serif text-3xl md:text-4xl tracking-tight leading-tight">An interdisciplinary, global, non-dogmatic alliance.</h2>
          </div>
          <div className="md:col-span-7 space-y-6 text-[#1f2937] leading-relaxed">
            <p>{p.what_is?.body}</p>
            <div className="border-l-2 border-[#D4AF37] pl-6">
              <div className="bsca-eyebrow text-[#7A5A06]">{p.why_now?.title}</div>
              <p className="mt-2 text-[#4B5563]">{p.why_now?.body}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid md:grid-cols-2 gap-12">
          <div>
            <SectionEyebrow>{p.who_for?.title || "Who it is for"}</SectionEyebrow>
            <ul className="mt-6 space-y-3">
              {(p.who_for?.items || []).map((it) => (
                <li key={it} className="flex items-start gap-3">
                  <Check className="h-4 w-4 text-[#D4AF37] mt-1.5 shrink-0" />
                  <span className="text-[#1f2937]">{it}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <SectionEyebrow>{p.what_we_do?.title || "What we do"}</SectionEyebrow>
            <ul className="mt-6 space-y-3">
              {(p.what_we_do?.items || []).map((it) => (
                <li key={it} className="flex items-start gap-3">
                  <Check className="h-4 w-4 text-[#D4AF37] mt-1.5 shrink-0" />
                  <span className="text-[#1f2937]">{it}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="bsca-dark bsca-cosmic bsca-grain py-24 relative overflow-hidden">
        <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
          <SectionEyebrow dark>{p.how_to_participate?.title || "How to participate"}</SectionEyebrow>
          <h2 className="font-serif text-4xl md:text-5xl text-white tracking-tight">{p.how_to_participate?.body}</h2>
          <Link to={p.how_to_participate?.cta?.href || "/engage#join"} data-testid="btn-alliance-join" className="mt-10 inline-flex items-center bg-[#D4AF37] text-[#050B14] font-medium px-8 py-4 rounded-sm bsca-lift">
            {p.how_to_participate?.cta?.label || "Join BSCA"} <ArrowRight className="h-4 w-4 ml-2" />
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
